import { render, staticRenderFns } from "./ItemDetailsModal.vue?vue&type=template&id=c20e3000&scoped=true"
import script from "./ItemDetailsModal.vue?vue&type=script&lang=js"
export * from "./ItemDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailsModal.vue?vue&type=style&index=0&id=c20e3000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e3000",
  null
  
)

export default component.exports